// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"SingleResultModal_fadeIn__xI7KA"};